module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hold-transition login-page",
    attrs: {
      "id": "login"
    },
    on: {
      "click": function($event) {
        _vm.closeLangOption()
      }
    }
  }, [_c('div', {
    class: [_vm.app.pcDisp ? 'bg-img-pc' : 'bg-img-mobile ' + _vm.bgFilter]
  }, [_c('div', {
    staticClass: "login-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-body"
  }, [_c('div', {
    staticClass: "body-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginDisp),
      expression: "loginDisp"
    }],
    staticClass: "box-login clearfix"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.userBase))]), _vm._v(" "), _c('div', {
    staticClass: "group-language"
  }, [_c('div', {
    staticClass: "lang-display",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toggleLangOption()
      }
    }
  }, [_c('div', {
    staticClass: "lang-item"
  }, [_c('div', {
    staticClass: "lang-icon"
  }, [_c('img', {
    staticClass: "img-language",
    attrs: {
      "src": require('static/images/flag_' + _vm.langFocus.icon + '_icon.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lang-text"
  }, [_vm._v(_vm._s(_vm.langFocus.desc))]), _vm._v(" "), _c('div', {
    staticClass: "lang-icon-select"
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.dispLangOption ? 'fa-chevron-up' : 'fa-chevron-down']
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dispLangOption),
      expression: "dispLangOption"
    }],
    staticClass: "lang-option"
  }, _vm._l((_vm.app.allLang), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "lang-item",
      class: [value === _vm.app.nowLang ? 'selected' : ''],
      on: {
        "click": function($event) {
          _vm.switchLang(value)
        }
      }
    }, [_c('div', {
      staticClass: "lang-icon"
    }, [_c('img', {
      staticClass: "img-language",
      attrs: {
        "src": require('static/images/flag_' + value + '_icon.png')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "lang-text"
    }, [_vm._v(_vm._s(_vm.descLang[value]))])])
  }))]), _vm._v(" "), _c('label', {
    staticClass: "box-input-material position-up clearfix"
  }, [_c('div', {
    staticClass: "glyphicon glyphicon-user icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "upper",
    class: {
      'focus': _vm.username != '', 'input-error': _vm.errors.has('username')
    },
    attrs: {
      "name": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.$refs.passwordInput.focus()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['20']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])]), _vm._v(" "), _c('label', {
    staticClass: "box-input-material clearfix"
  }, [_c('div', {
    staticClass: "fa fa-key icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "passwordInput",
    class: {
      'focus': _vm.password != '', 'input-error': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.callSignIn()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['30']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), (_vm.loadingDisp) ? _c('div', {
    staticClass: "infinite-loading-container"
  }, [_c('i', {
    staticClass: "loading-wave-dots"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.response !== ''),
      expression: "response !== ''"
    }],
    staticClass: "response-msg"
  }, [_vm._v(_vm._s(_vm.response))]), _vm._v(" "), _c('div', {
    staticClass: "link-forgot",
    on: {
      "click": function($event) {
        _vm.goForgotPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['50']) + " ?")]), _vm._v(" "), _c('div', {
    staticClass: "link-change",
    on: {
      "click": function($event) {
        _vm.goChange()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['60']))]), _vm._v(" "), _c('button', {
    staticClass: "btn-login submit",
    attrs: {
      "rel": "go_item3",
      "id": "btn-login"
    },
    on: {
      "click": function($event) {
        _vm.callSignIn()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['10']))])]), _vm._v(" "), _c('forgot-password', {
    attrs: {
      "forgotPasswordDisp": _vm.forgotPasswordDisp,
      "forgotPasswordVerifyDisp": _vm.forgotPasswordVerifyDisp,
      "pcDisp": _vm.app.pcDisp,
      "goLogin": _vm.goLogin,
      "inputUsername": _vm.inputUsername,
      "loadingDisp": _vm.loadingDisp,
      "postForgotPassword": _vm.postForgotPassword,
      "postForgotPasswordVerify": _vm.postForgotPasswordVerify,
      "response": _vm.response,
      "setForgotPasswordResponse": _vm.setForgotPasswordResponse,
      "labels": _vm.labels[_vm.app.nowLang]
    }
  }), _vm._v(" "), _c('change-password', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changePasswordDisp),
      expression: "changePasswordDisp"
    }],
    attrs: {
      "pcDisp": _vm.app.pcDisp,
      "goLogin": _vm.goLogin,
      "inputUsername": _vm.inputUsername,
      "postChangePassword": _vm.postChangePassword,
      "changePasswordResponse": _vm.changePasswordResponse,
      "setChangePasswordResponse": _vm.setChangePasswordResponse,
      "flgAction": _vm.flgAction,
      "formatPassword": _vm.formatPassword,
      "setMsgFormatPassword": _vm.setMsgFormatPassword,
      "labels": _vm.labels[_vm.app.nowLang]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-footer"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "base-conn"
  }, [_vm._v(_vm._s(_vm.baseConn.user) + "@" + _vm._s(_vm.baseConn.db))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "company-logo"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img/login/company-logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "software-name"
  }, [_c('div', {
    staticClass: "header1"
  }, [_vm._v("TOG Smart Life")]), _vm._v(" "), _c('div', {
    staticClass: "build-time"
  }, [_vm._v("ESS Version")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "software-logo"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("src/assets/img/login/logo_pps.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53397320!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/component.vue
// module id = 3759
// module chunks = 1